import _regeneratorRuntime from "/Users/antoineprovost/Documents/Comparateur/front-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/antoineprovost/Documents/Comparateur/front-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/antoineprovost/Documents/Comparateur/front-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/antoineprovost/Documents/Comparateur/front-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/antoineprovost/Documents/Comparateur/front-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/antoineprovost/Documents/Comparateur/front-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { WebPlugin } from '@capacitor/core';
export var GeolocationWeb = /*#__PURE__*/function (_WebPlugin) {
  _inherits(GeolocationWeb, _WebPlugin);

  var _super = _createSuper(GeolocationWeb);

  function GeolocationWeb() {
    _classCallCheck(this, GeolocationWeb);

    return _super.apply(this, arguments);
  }

  _createClass(GeolocationWeb, [{
    key: "getCurrentPosition",
    value: function () {
      var _getCurrentPosition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  navigator.geolocation.getCurrentPosition(function (pos) {
                    resolve(pos);
                  }, function (err) {
                    reject(err);
                  }, Object.assign({
                    enableHighAccuracy: false,
                    timeout: 10000,
                    maximumAge: 0
                  }, options));
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getCurrentPosition(_x) {
        return _getCurrentPosition.apply(this, arguments);
      }

      return getCurrentPosition;
    }()
  }, {
    key: "watchPosition",
    value: function () {
      var _watchPosition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(options, callback) {
        var id;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                id = navigator.geolocation.watchPosition(function (pos) {
                  callback(pos);
                }, function (err) {
                  callback(null, err);
                }, Object.assign({
                  enableHighAccuracy: false,
                  timeout: 10000,
                  maximumAge: 0
                }, options));
                return _context2.abrupt("return", "".concat(id));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function watchPosition(_x2, _x3) {
        return _watchPosition.apply(this, arguments);
      }

      return watchPosition;
    }()
  }, {
    key: "clearWatch",
    value: function () {
      var _clearWatch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(options) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                window.navigator.geolocation.clearWatch(parseInt(options.id, 10));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function clearWatch(_x4) {
        return _clearWatch.apply(this, arguments);
      }

      return clearWatch;
    }()
  }, {
    key: "checkPermissions",
    value: function () {
      var _checkPermissions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var permission;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(typeof navigator === 'undefined' || !navigator.permissions)) {
                  _context4.next = 2;
                  break;
                }

                throw this.unavailable('Permissions API not available in this browser');

              case 2:
                _context4.next = 4;
                return window.navigator.permissions.query({
                  name: 'geolocation'
                });

              case 4:
                permission = _context4.sent;
                return _context4.abrupt("return", {
                  location: permission.state,
                  coarseLocation: permission.state
                });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function checkPermissions() {
        return _checkPermissions.apply(this, arguments);
      }

      return checkPermissions;
    }()
  }, {
    key: "requestPermissions",
    value: function () {
      var _requestPermissions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                throw this.unimplemented('Not implemented on web.');

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function requestPermissions() {
        return _requestPermissions.apply(this, arguments);
      }

      return requestPermissions;
    }()
  }]);

  return GeolocationWeb;
}(WebPlugin);
var Geolocation = new GeolocationWeb();
export { Geolocation };